import {
    MoreVert, Delete,
} from '@mui/icons-material';
import {
    Box,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material';
import { useState } from 'react';
import { DeleteConfirmationDialog } from '../common/DeleteConfirmationDialog';
import { ViewStrategyButton } from '../common/buttons/ViewStrategyButton';

interface TopBarActionsProps {
    onDelete: () => Promise<void>;
    strategy: Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy;
    selectedVariantIndex: number;
}

export const TopBarActions = ({ onDelete, strategy, selectedVariantIndex }: TopBarActionsProps): JSX.Element => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const open = Boolean(anchorEl);

    const handleSettingsClick = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (): void => {
        setAnchorEl(null);
    };

    const handleDeleteClick = (): void => {
        setDeleteDialogOpen(true);
        handleClose();
    };

    const handleDeleteConfirm = async (): Promise<void> => {
        await onDelete();
        setDeleteDialogOpen(false);
        handleClose();
    };

    const handleDeleteCancel = (): void => {
        setDeleteDialogOpen(false);
    };

    return (
        <>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <ViewStrategyButton
                    selectedVariantIndex={selectedVariantIndex}
                    strategy={strategy}
                />

                <IconButton
                    aria-label="settings"
                    onClick={handleSettingsClick}
                >
                    <MoreVert />
                </IconButton>
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleDeleteClick}>
                    <ListItemIcon>
                        <Delete color="error" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ color: 'error' }}>
                        Delete Strategy
                    </ListItemText>
                </MenuItem>
            </Menu>
            <DeleteConfirmationDialog
                description="Are you sure you want to delete this strategy? This action cannot be undone."
                open={deleteDialogOpen}
                title="Delete Strategy"
                onCancel={handleDeleteCancel}
                onDelete={handleDeleteConfirm}
            />
        </>
    );
};
